import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "block truncate text-placeholder text-greyScale500"
}
const _hoisted_3 = {
  key: 1,
  class: "block truncate"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "pointer-events-none absolute inset-y-0 right-4 flex items-center pr-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "10px",
    height: "6px",
    viewBox: "0 0 10 6",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Symbols",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "menu",
        transform: "translate(-635, -27)",
        fill: "#AAAABD",
        "fill-rule": "nonzero"
      }, [
        /*#__PURE__*/_createElementVNode("g", {
          id: "navigation",
          transform: "translate(272, 16)"
        }, [
          /*#__PURE__*/_createElementVNode("g", {
            id: "link-dropdown",
            transform: "translate(304, 0)"
          }, [
            /*#__PURE__*/_createElementVNode("g", {
              id: "icons/ui/chevron-down",
              transform: "translate(59, 11)"
            }, [
              /*#__PURE__*/_createElementVNode("path", { d: "M0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L5,3.585 L8.29289322,0.292893219 C8.65337718,-0.0675907428 9.22060824,-0.0953202783 9.61289944,0.209704612 L9.70710678,0.292893219 C10.0976311,0.683417511 10.0976311,1.31658249 9.70710678,1.70710678 L5.70710678,5.70710678 C5.31658249,6.09763107 4.68341751,6.09763107 4.29289322,5.70710678 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 Z" })
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

import { computed } from 'vue';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';


export default {
  __name: 'Select',
  props: {
    options: {
        type: [Array, null],
    },
    selected: {
        type: [String, null],
    },
    placeholder: {
        type: String,
        default: 'Wybierz',
    },
},
  setup(__props) {

const props = __props;



const selectedName = computed(() => {
    if (!props.selected) return null;
    const option = props.options.find((option) => option.id === props.selected);
    return option ? option.title : null;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Listbox), {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.$emit('onChange', $event))),
    modelValue: __props.selected
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), { class: "Button--no-style relative w-full min-h-[56px] lg:min-h-[72px] cursor-default rounded-lg border-[1px] border-greyScale200 py-2 px-5 lg:px-8 text-left focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm" }, {
          default: _withCtx(() => [
            (!_unref(selectedName))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.placeholder), 1))
              : _createCommentVNode("", true),
            (_unref(selectedName))
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(selectedName)), 1))
              : _createCommentVNode("", true),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          "leave-active-class": "transition duration-100 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (__props.options.length)
              ? (_openBlock(), _createBlock(_unref(ListboxOptions), {
                  key: 0,
                  class: "absolute mt-1 z-10 w-full max-h-[240px] lg:max-h-[289px] overflow-auto rounded-md bg-greyScale50 py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                      return (_openBlock(), _createBlock(_unref(ListboxOption), {
                        key: option.id,
                        value: option.id,
                        as: "template"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["hover:bg-gray-100 cursor-pointer flex items-center relative select-none min-h-[56px] lg:min-h-[72px] px-8", [
                                option.id === __props.selected
                                    ? 'bg-gray-100 text-primary'
                                    : 'text-gray-900',
                            ]])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                                    option.id === __props.selected ? 'font-medium' : 'font-normal',
                                    'block truncate',
                                ])
                            }, _toDisplayString(option.title), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

}